<template>
  <ApplicationLayout v-if="!isService" />
  <ServiceLayout v-else />
</template>

<script setup>
import ApplicationLayout from '@/layouts/ApplicationLayout.vue';
import ServiceLayout from '@/layouts/ServiceLayout.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const isService = computed(() => {
  return route.meta.isService;
});
</script>

<style scoped lang="scss"></style>
